import { assertNever } from '@kofno/piper';

import CopyStore from './index';
import { State } from './Types';
import ReactionComponent from '../../../ReactionComponent';

interface Props {
  store: CopyStore;
}

class CopyToClipboardReactions extends ReactionComponent<CopyStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'copying':
        navigator.clipboard.writeText(store.text);
        store.copied();
        break;
      case 'copied':
        setTimeout(() => {
          store.waiting();
        }, 1500);
        break;
      default:
        assertNever(state);
    }
  };
}

export default CopyToClipboardReactions;
